import { render, staticRenderFns } from "./AttendanceRemedy.vue?vue&type=template&id=02c8ae2d&scoped=true"
import script from "./AttendanceRemedy.vue?vue&type=script&lang=js"
export * from "./AttendanceRemedy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c8ae2d",
  null
  
)

export default component.exports